<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Home</h3>
      </div>
    </div>
    <div class="content-body">
      <!--<div class="row" v-if="useWallet()">-->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="media d-flex">
                  <div class="align-self-top">
                    <i class="icon-wallet icon-opacity font-large-4 float-left"></i>
                  </div>
                  <div class="media-body text-right align-self-bottom">
                    <span class="d-block mb-1 font-medium-1">Wallet Balance</span>
                    <h1 class="mb-0">R{{balance}}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <img v-bind:src="merchantPic()" class="merchant-pic" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <!--<router-link v-bind:to="orderNow()" class="btn mb-1 btn-primary btn-lg btn-block">Order Now</router-link>-->
                <router-link to="/calendar" class="btn mb-1 btn-primary btn-lg btn-block">Pre-Order</router-link>
                <router-link to="/qrcode" class="btn mb-1 btn-primary btn-lg btn-block">Show QR Code</router-link>
                <router-link v-if="useWallet()" to="/wallet" class="btn mb-1 btn-primary btn-lg btn-block">Top-up Wallet</router-link>

                <!--<router-link to="/meetingroom" class="btn mb-1 btn-primary btn-lg btn-block">Meeting Room Order</router-link>-->
                <router-link to="/today" class="btn mb-1 btn-primary btn-lg btn-block">View Today's Orders</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'home',
  data: function () {
    return {
      merchants: this.getMerchants(),
      merchantId: this.getMerchantId()
    }
  },
  mounted: function () {
    this.merchantPic()

    window.localStorage.removeItem('boardroomId')
    window.localStorage.removeItem('boardroomTime')
  },
  computed: {
    balance: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.wallet_balance
    }
  },
  methods: {
    useWallet: function () {
      var output = false

      var user = JSON.parse(window.localStorage.getItem('user'))
      user.parent.company.merchants.forEach(function (merchant) {
        if (window.localStorage.getItem('merchantId') && merchant.id === window.localStorage.getItem('merchantId')) {
          if (merchant.use_wallet === 'Y') {
            output = true
          }
        }
      })

      return output
    },
    orderNow: function () {
      var currentDate = moment().format('YYYY-MM-DD')
      return 'preorder/' + currentDate + '/1'
    },
    getMerchants: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      if (user && user.parent && user.parent.company && user.parent.company.merchants) {
        return user.parent.company.merchants
      }
    },
    getMerchantId: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))

      if (window.localStorage.getItem('merchantId')) {
        return window.localStorage.getItem('merchantId')
      } else {
        window.localStorage.setItem('merchantId', user.parent.company.merchants[0].id)
        return user.parent.company.merchants[0].id
      }
    },
    merchantPic: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return 'https://admin.goldenspoon.co.za/assets/uploads/merchants/logo/' + user.parent.company.merchants[0].logo
    }
  }
}
</script>

<style scoped>
.merchant-pic {
  margin: 0 auto 10px auto;
  max-width:100%;
}
</style>
